import _ from 'lodash';
import * as d3 from 'd3';


/*let width = 0
let height = 0
let chartWidth = 0
let chartHeight = 0*/

const xScale = d3.scaleBand()
const yScale = d3.scaleLinear()
const parseYear = d3.timeParse('%Y')
const formatYear = d3.timeFormat('%Y')
const stack = d3.stack()

const formatPercent = d3.format(",.0%")
const formatPercent2 = d3.format(",.1%")

const formatVoters = d3.format(",d")

const years = ['2010', '2012', '2014', '2016']
const headerLabels = ["year", "votes", "percent"]
const pinch = 20
const tickPadding = 12

const mobile = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)

export default () => ({

  render() {

    let props = {
        width: 0,
        height: 0,
        margin: {},
        yTicks: 0,
        tooltip: false,
    }

    function barchart(container) {
      const data = container.datum()

      const chartWidth = props.width - props.margin.right - props.margin.left
      const chartHeight =  props.height - props.margin.top - props.margin.bottom;
      function enter() {

        const svg = container.selectAll('svg').data([data])
        const svgEnter = svg.enter().append("svg").attr("class", "bar-svg")
        const gEnter = svgEnter.append('g')
        gEnter.append("g").attr("class", "axis--x axis")
        gEnter.append("g").attr("class", "axis--y axis")
        gEnter.append("g").attr("class", "bars")
        gEnter.append("g").attr("class", "labels")
        gEnter.append("g").attr("class", "percents")
        

      }

      function updateScales() {

        //console.log(d3.extent(_.flatten(data.map(arr => d3.extent(arr.values, d => d.day))))
        const xExtent = data.map(d => parseYear(d.year))

        xScale
          .domain(xExtent)
          .range([0, chartWidth])
          .paddingInner(0.3)
          .paddingOuter(3)

        const yMax = d3.max(data, d => d.totalturnout)
        //const yMax = d3.max(_.flatten(data.map(arr => d3.max(arr.values, d => d.cumulative_in_person))), d => d)
        //const yMax = d3.max(_.flatten(data.map(arr => d3.max(arr.values, d => d[field]/d['reg_voters']))), d => d)
        //console.log(yMax)
        yScale
          .domain([0, yMax])
          .rangeRound([chartHeight, 0])
          .nice()

        const svg = container.select("svg")
        const g = svg.select('g')

        const xAxisG = g.select(".axis--x")
        const yAxisG = g.select(".axis--y")

        const xAxis = d3.axisBottom(xScale)
          .tickFormat(formatYear)
          //.ticks(6)

        const yAxis = d3.axisLeft(yScale)
          .tickFormat(formatPercent)
          .tickPadding(tickPadding)
          .tickSize(-chartWidth - tickPadding)
          .ticks(3)

        const xAxisGEnter = xAxisG
          .attr('transform', `translate(0, ${chartHeight})`)
          .call(xAxis)

        const yAxisGEnter = yAxisG
          .attr('transform', `translate(${-props.margin.left/4}, 0)`)
          .call(yAxis)

        yAxisGEnter.selectAll(".tick:first-of-type text").remove()

      }

      function updateDom() {
          const svg = container.select("svg")

          svg
            .attr('width', props.width)
            .attr('height', props.height)

          const g = svg.select('g')

          g.attr('transform', `translate(${props.margin.left}, ${props.margin.top})`)

          const bars = g.select(".bars")
          const bar = bars.selectAll(".bar")
            .data(stack.keys(Object.keys(data[0]).slice(4,6))(data))
          
          const barEnter = bar 
            .enter()
            .append("g")
            .attr("class", d => `bar bar-${d.key}`)
          .merge(bar)

        

          const subbar = barEnter.selectAll(".subbar")
            .data(d => d)

          //barEnter
          subbar
            .enter()
            .append("rect")
            .attr("class", "subbar")
          .merge(subbar)
            .attr("x", d => xScale(parseYear(d.data.year)))
            .attr("y", d => yScale(d[1]))
            .attr("height", d => yScale(d[0]) - yScale(d[1]))
            .attr("width", xScale.bandwidth())
            

          const percents = g.select(".percents")

          const percent = percents.selectAll(".percent-label")
            .data(data)
          
          percent
            .enter()
            .append("text")
            .attr("class", "percent-label")
          .merge(percent)
            .text(d => formatPercent2(d.totalturnout))
            .attr("x", d => xScale(parseYear(d.year)) + xScale.bandwidth()/2)
            .attr("y", d => yScale(d.totalturnout) - 5)

          const labels = g.select(".labels")
          const labelG = labels.selectAll(".label-g")
            .data(stack.keys(Object.keys(data[0]).slice(4,6))(data))

          const labelGEnter = labelG 
            .enter()
            .append("g")
            .attr("class", d => `label-g label-g-${d.key}`)
          .merge(labelG)

          const label = labelGEnter.selectAll(".label")
            .data(d => {
              d.slice(-2,2).map(x => {
                x['cut'] = d.key
              })
              d = d.filter((x,i) => x[1] - x[0] != 0)
              return d
            })

          //barEnter
          const labelEnter = label

            .enter()
            .append("g")
            .attr("class", "label")

          /*labelEnter
            .append("circle")
            .attr("class", "label-circle")
           

          labelEnter
            .append("line")
            .attr("class", "label-line")*/
            

          labelEnter
            .append("text")
            .attr("class", "label-text")
          
          const labelUpdate = labelEnter.merge(label)
          
          /*labelUpdate
            .select(".label-circle")
            .attr("cx", d => xScale(parseYear(d.data.year)) + xScale.bandwidth()/2)
            .attr("cy", d => yScale((d[0] + d[1])/2))
            .attr("r", 3)

          labelUpdate
            .select(".label-line")
            .attr("x1", d => xScale(parseYear(d.data.year)) + xScale.bandwidth()/2)
            .attr("x2", (d,i) => xScale(parseYear(d.data.year)) + (i == 0 ? -xScale.bandwidth()/2 : xScale.bandwidth()*1.5))
            .attr("y1", d => yScale((d[0] + d[1])/2))
            .attr("y2", d => yScale((d[0] + d[1])/2))
            .attr("stroke", "black")*/

          labelUpdate
            .select(".label-text")
            .attr("y", (d,i) => yScale((d[0] + d[1])/2) + (i == 0 && 10))
            .text(d => d.cut == 'earlyturnout' ? "Early voting and mail-in ballots" : "Election day ballots")
            .attr("dy", "1.15em")
            .attr("text-anchor", (d,i) =>  i == 0 ? "end" : "start")
            .attr("x", function(d,i) {
              const textWidth = d3.select(this).node().getBoundingClientRect().width
              return xScale(parseYear(d.data.year)) + (i == 0 ? (-xScale.bandwidth()/8) : xScale.bandwidth()*9/8)
            })
            .call(wrap, 75)

          labelUpdate
            .select(".label-text")
            

            //.text(d => )
          



            


      }

      enter()
      updateScales()
      updateDom()

    }

    barchart.props = (obj) => {
      if (!obj) return props;
      props = Object.assign(props, obj);
      return barchart;
    }
    return barchart
  },

  draw() {
    const chart = this.render()
      .props(this._props);

    this._selection
      .datum(this._data)
      .call(chart);
  },

  // We use the create method to initially draw our chart
  // Unlike the update and resize methods, this method expects our actual html selector
  // (which is needed by our chart function to actually draw the chart)
  // We also pass in our data and custom props object here.
  create(selection, data, props) {
    this._selection = selection;
    this._data = data;
    this._props = props || {};

    this.draw();
  },

  // Method that is useful for updating our chart with new data.
  update(data) {
    this._data = data;
    this.draw();
  },

  // Helper method to resize our chart and make it responsive.
  resize() {
    this.draw();
  },
})

function wrap(text, width) {
  text.each(function() {
    var text = d3.select(this),
        words = text.text().split(/\s+/).reverse(),
        word,
        line = [],
        lineNumber = 0,
        lineHeight = 1.15,
        x = text.attr("x"),
        y = text.attr("y"),
        dy = parseFloat(text.attr("dy")),
        tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", 0 + "em");
    while (word = words.pop()) {
      line.push(word);
      tspan.text(line.join(" "));
      if (tspan.node().getComputedTextLength() > width) {
        line.pop();
        tspan.text(line.join(" "));
        line = [word];
        tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + "em").text(word);
      }
    }
  });
}
